export default "__VITE_ASSET__CL56olJY__"